import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-start justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              >
                <span className="font-heading text-sm font-semibold leading-relaxed text-foreground-950 md:text-base">
                  {item.question}
                </span>
                <span
                  className={`mt-[2px] flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-sm transition-colors ${
                    isOpen
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 text-foreground-600"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                </span>
              </button>
            </h3>
            {isOpen ? (
              <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                {item.answer}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}